import {
  AddressField,
  CheckboxField,
  CountryField,
  EmailField,
  InputField,
  LeadCapturePersonField,
  OrganisationField,
  PostcodeField,
  ProductInterestsField,
  RoleField,
  SchoolField,
  SchoolSizeField,
  SelectField,
  TextareaField,
  TextField,
} from "@/components/fields";
import NumberField from "@/components/fields/NumberField.vue";
import ProductField from "@/components/fields/ProductField.vue";
import { App } from "vue";

export const contactCaptureComponents = {
  AddressField,
  CheckboxField,
  CountryField,
  EmailField,
  InputField,
  LeadCapturePersonField,
  NumberField,
  OrganisationField,
  PostcodeField,
  ProductField,
  ProductInterestsField,
  RoleField,
  SchoolField,
  SchoolSizeField,
  SelectField,
  TextField,
  TextareaField,
};

/**
 * Register components that are passed by wagtail templates.
 */
export function registerLeadCaptureComponents(app: App) {
  app.component("address-field", AddressField);
  app.component("country-field", CountryField);
  app.component("email-field", EmailField);
  app.component("input-field", InputField);
  app.component("lead-capture-person-field", LeadCapturePersonField);
  app.component("organisation-field", OrganisationField);
  app.component("postcode-field", PostcodeField);
  app.component("product-field", ProductField);
  app.component("product_interest_multi_select", ProductInterestsField);
  app.component("role-field", RoleField);
  app.component("school-field", SchoolField);
  app.component("school-size-field", SchoolSizeField);
  app.component("select-field", SelectField);
  app.component("text-field", TextField);

  return app;
}

/**
 * Return a new string with any emoticons removed.
 *
 * @param string
 */
export function removeEmoticons(string?: string | null) {
  if (!string) {
    return string;
  }
  const emoticonsRegex =
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
  return string.replace(emoticonsRegex, "");
}
